import Contracts from '@/views/contract/Contracts.vue'
import contractModalRouter from '@/router/routers/contractModal'

const contractRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Contratos',
        path: '/contratos',
        meta: {
            requiresAuth: true,
            breadcrumb: true,
            breadcrumbName: 'Contratos',
            layout: 'default'
        },
        component: Contracts,
        children: [
            contractModalRouter(beforeEnter, 'CadastrarContrato', 'contratos', false),
            contractModalRouter(beforeEnter, 'DetalheContrato', 'contratos', true),
            contractModalRouter(beforeEnter, 'EditarContrato', 'contratos', true)
        ]
    }
}

export default contractRouter
